
export const processImage = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    // Verificar se é um arquivo de imagem válido
    if (!file.type.startsWith('image/')) {
      reject(new Error('O arquivo fornecido não é uma imagem válida'));
      return;
    }

    // Criar objetos URL apenas uma vez e liberá-los após o uso
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    
    img.onload = () => {
      // Criar canvas para redimensionar a imagem
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx) {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Falha ao obter contexto do canvas'));
        return;
      }
      
      // Calcular dimensões preservando a proporção
      let width = img.width;
      let height = img.height;
      const maxSize = 800;
      
      // Usar cálculos otimizados para redimensionamento
      if (width > height && width > maxSize) {
        height = Math.floor(height * maxSize / width);
        width = maxSize;
      } else if (height > maxSize) {
        width = Math.floor(width * maxSize / height);
        height = maxSize;
      }
      
      // Definir dimensões do canvas e desenhar imagem redimensionada
      canvas.width = width;
      canvas.height = height;
      
      // Usar algoritmo de renderização otimizado
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, width, height);
      
      // Configurações de compressão otimizadas - qualidade 0.7 é bom equilíbrio
      canvas.toBlob(blob => {
        // Liberar memória do objectURL
        URL.revokeObjectURL(objectUrl);
        
        if (!blob) {
          reject(new Error('Falha ao criar blob da imagem'));
          return;
        }
        
        // Criar novo arquivo a partir do blob
        const processedFile = new File([blob], file.name, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
        
        resolve(processedFile);
      }, 'image/jpeg', 0.7); // Qualidade reduzida para 0.7 para melhorar performance
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Falha ao carregar imagem'));
    };
    
    // Carregar imagem
    img.src = objectUrl;
  });
};
